import React, { useState } from "react";
import Sidebar from "../components/sidebar";
import Navbar from "../components/navbar";
import down from "../imgs/down.svg";
import mobileicon from "../imgs/9mobileicon.svg";
import mtn from "../imgs/mtn.svg";
import airtel from "../imgs/airtel.svg";

function Airtimetocash() {
  const [page, setPage] = useState("airtimetocash");
  const [dropdown, setDropdown] = useState(false);
  return (
    <div className="flex">
      <Sidebar page={page} />
      <div className="w-full ml-[304px]">
        <Navbar page={page} />
        <div className="mt-8 px-8 flex w-full justify-center">
          <div className="w-[500px]">
            <div className="flex gap-2 ">
              <div className="flex flex-col items-center gap-2 w-full">
                <p className="leading-[16.94px] text-[14px] text-[#4169E1] font-semibold text-center">
                  Fill Info
                </p>
                <div className="bg-[#4169E1] h-[7px] w-full rounded-[100px]"></div>
              </div>
              <div className="flex flex-col items-center gap-2 w-full">
                <p className="leading-[16.94px] text-[14px] text-[#D7E1F4] font-semibold text-center">
                  Make Payment
                </p>
                <div className="bg-[#D7E1F4] h-[7px] w-full rounded-[100px]"></div>
              </div>
              <div className="flex flex-col items-center gap-2 w-full">
                <p className="leading-[16.94px] text-[14px] text-[#D7E1F4] font-semibold text-center">
                  View Receipt
                </p>
                <div className="bg-[#D7E1F4] h-[7px] w-full rounded-[100px]"></div>
              </div>
            </div>
            <div className="mt-[52px] bg-[#F7F9FD] rounded-xl border border-[#D7E1F4] p-6 gap-[54px]">
              <div className="flex flex-col items-center gap-8">
                <p className="text-[#6882B6] leading-[24.2px] text-[20px] font-semibold">
                  Airtime to Cash
                </p>
                <div className="mt-8 w-full flex flex-col gap-4">
                  <div className="flex gap-3">
                    <div className="w-full flex flex-col gap-[6px] relative">
                      <label className="text-[#6882B6]">Select Network</label>
                      <div
                        className="bg-white h-[50px] items-center flex px-2 py-[10px] border justify-between border-[#C7DBEF] rounded-lg"
                        onClick={() => {
                          setDropdown(!dropdown);
                        }}
                      >
                        <div className="flex items-center gap-1">
                          <img src={mobileicon} />
                          <p className="text-[#6882B6] leading-[16.94px] text-[14px] font-semibold">
                            Etisalat
                          </p>
                        </div>
                        <img src={down} alt="" />
                      </div>
                      {dropdown ? (
                        <div className="absolute mt-[82px] border w-[220px] p-3 bg-white rounded-lg">
                          <div className="flex items-center gap-3 border-b p-2 hover:shadow-md ">
                            <img src={mtn} alt="" className="w-7" />
                            <p className="font-semibold leading-4 text-slate-800">
                              MTN
                            </p>
                          </div>

                          <div className="flex items-center gap-3 border-b p-2 hover:shadow-md ">
                            <img src={airtel} alt="" className="w-7" />
                            <p className="font-semibold leading-4 text-slate-800">
                              Airtel
                            </p>
                          </div>
                          <div className="flex items-center gap-3 border-b p-2 hover:shadow-md ">
                            <img src={mobileicon} alt="" className="w-7" />
                            <p className="font-semibold leading-4 text-slate-800">
                              9mobile
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className="w-full flex flex-col gap-[6px]">
                      <label className="text-[#6882B6]">Phone Number</label>
                      <input
                        type="text"
                        className="p-2 border border-[#D7E1F4] rounded-lg py-[15.5px] text-[16px] font-semibold leading-[19.36px] bg-[#ffffff] outline-none"
                        placeholder="08094562627"
                      />
                    </div>
                  </div>
                  <div className="w-full flex flex-col gap-[6px]">
                    <label className="text-[#4C689E]">Amount</label>
                    <input
                      type="text"
                      className="p-2 border border-[#D7E1F4] rounded-lg py-[15.5px] font-semibold text-[16px] leading-[19.36px] bg-[#ffffff] outline-none"
                      placeholder="₦5,000"
                    />
                  </div>
                  <div className="w-full flex flex-col gap-[6px]">
                    <label className="text-[#4C689E]">Airtime Share Pin</label>
                    <input
                      type="number"
                      className="p-2 border border-[#D7E1F4] rounded-lg py-[15.5px] font-semibold text-[16px] leading-[19.36px] bg-[#ffffff] outline-none "
                      placeholder="1234567890"
                    />
                  </div>
                </div>
              </div>
              <button className="mt-4 py-[17px] w-full text-[#ffffff] bg-[#4169E1] rounded-[10px]">
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Airtimetocash;
